// extracted by mini-css-extract-plugin
export default {"app":"style_app__0jjOI"};